import ScrollToTop from "../../components/ScrollToTop.tsx";
import useDatalayer from "../../components/useDatalayer.tsx";
import WorthToKnowSectionComponent from "../../components/alternative-frontpages/WorthToKnowSectionComponent.tsx";
import {Link} from "react-router-dom";
import CallMeRTOComponent from "../../components/callMe/CallMeRTOComponent.tsx";
import StudizHeroComponent from "../../components/hero/StudizHeroComponent.tsx";
import setNoIndexMeta from "../../components/setNoIndexMeta.tsx";
import AlternativeFrontpagesTitleAndMetaDescription from "../../components/alternative-frontpages/AlternativeFrontpagesTitleAndMetaDescription.tsx";
import {CallMePhoneNumbers} from "../../util/contact.ts";
import {imageMap} from "../../images/imageMap.ts";
import TrustBox from "../../components/trustpilot/trustBoxComponent.tsx";

export default function StudizPage() {
    ScrollToTop()
    useDatalayer()
    setNoIndexMeta()
    AlternativeFrontpagesTitleAndMetaDescription()


    return (
    <div className={"page-campaign-studiz"}>
        <StudizHeroComponent />
        <section className="section-includes">
            <div className="content content--narrow">
                <div className="blurb">
                    <h3 className="heading heading--big">Billigt og hurtigt internet til studerende </h3>
                </div>
                <ul className="grid grid-triple no-boxes">
                    <li>
                        <p>
                            Er du studerende og på jagt efter billigt internet, der stadig leverer på hastighed og
                            stabilitet?
                            Hos Hiper ved vi, at SU’en ikke er stor – men at behovet for hurtigt bredbånd er.
                            Derfor tilbyder vi billigt internet til studerende, uden at gå på kompromis med kvaliteten.
                        </p>
                    </li>
                </ul>
                <ul className="grid grid-triple no-boxes">
                    <li>
                        <img src={imageMap.alternative_frontpages.students} alt="Studerende bruger hiper" />
                    </li>
                    <li>
                        <p>
                            <strong>Internet til studerende – hurtigt, stabilt og fleksibelt</strong><br />
                            Som studerende streamer du måske forelæsninger, deltager i online undervisning, gamer eller
                            slapper af med Netflix.
                            Det kræver en solid internetforbindelse – og det får du hos os. Vi vil som udgangspunkt
                            anbefale 5G-internet til
                            studerende, da det er den billigste internetforbindelse, vi udbyder, som samtidig er hurtig.
                            Lav et adresseopslag for at se, hvilket tilbud som du kan få.
                        </p>
                    </li>
                </ul>
            </div>
        </section>

        <CallMeRTOComponent phoneNumberSet={CallMePhoneNumbers.Default} className={"rto--box page-home"} />

        <section className="section-includes">
            <div className="content content--narrow">
                <div className="blurb">
                    <h3 className="heading heading--big">Det får du med i dit abonnement</h3>
                </div>
                <ul className="grid grid-triple no-boxes">
                    <li>
                        <img src={imageMap.products.router_fiber2} alt="Zyxel router" />
                    </li>
                    <li>
                        <p>
                            <strong>Router følger med</strong><br />
                            Bestiller du internet fra Hiper får du en af markedets bedste og nyeste routere med, som
                            sikrer dig lynhurtigt internet.
                            Med routeren kan du selv vælge, om du vil benytte wifi i din bolig, eller om du ønsker en
                            kablet LAN-forbindelse.
                        </p>
                        <Link to="/hjaelp/udstyr/hvilken-router-foelger-med">Læs mere om routeren</Link>
                    </li>
                </ul>
                <ul className="grid grid-triple no-boxes">
                    <li>
                        <img src={imageMap.products.mit_hiper} alt="Mit Hiper selvbetjening" />
                    </li>
                    <li>
                        <p>
                            <strong>Adgang til egen selvbetjening</strong><br />
                            Når du bestiller et abonnement hos Hiper, så får du adgang til din egen selvbetjening, Mit
                            Hiper, hvor du kan finde dine regninger, skifte betalingskort m.m..
                        </p>
                    </li>
                </ul>
            </div>
        </section>

        <WorthToKnowSectionComponent />

        <div className="usp-campaign-container">
            <h2 className="heading heading--medium">Derfor skal du vælge internet fra Hiper</h2>
            <div className="usp-content">
                <div className="image">
                    <img className={'trophies'} src={imageMap.home.mvfp_pokal}
                        alt="Vinder Mest Værdi For Pengene 2020, 2021, 2022, 2023, 2024 og 2025." />
                </div>
                <div className="text">
                    <p>
                        Med Hiper får du en hurtig og stabil internetforbindelse til én af markedets bedste priser.
                        Et Lynhurtigt internet med al den hastighed du skal bruge til at streame, game og arbejde på.
                    </p>
                    <p>
                        Vores vigtigste opgave er at give vores kunder den bedste internetoplevelse.
                        Fordi en god forbindelse handler for os om mere end hastighed og pris.
                        Det handler også om at sikre dig en stabil forbindelse, der lever op til hele familiens behov.
                    </p>
                    <p>
                        Hiper har vundet &ldquo;Mest værdi for pengene&rdquo; &ndash;
                        og for sjette år i træk giver vi alle vores kunder mest værdi for pengene
                        blandt alle internetudbydere i 2020, 2021, 2022, 2023, 2024 og 2025.
                    </p>
                </div>
            </div>
            <TrustBox templateId={"539ad0ffdec7e10e686debd7"} height={"350px"} />
        </div>
    </div>
    )
    }
